"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bindingsToString = void 0;
const rdf_string_1 = require("rdf-string");
/**
 * Stringify a bindings object.
 * @param bindings A bindings object.
 */
function bindingsToString(bindings) {
    const raw = {};
    for (const key of bindings.keys()) {
        raw[key.value] = (0, rdf_string_1.termToString)(bindings.get(key));
    }
    return JSON.stringify(raw, null, '  ');
}
exports.bindingsToString = bindingsToString;
//# sourceMappingURL=bindingsToString.js.map